import { SubmittedAgendaItem } from "./SubmittedAgendaItem";

export default SubmittedAgendaItem;
